/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoSearchRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
  useMutation,
  MutationHookOptions,
  MutationTuple,
} from 'data-fetching-client';
import * as References from './HubSpotVideoSearchRpc';
import * as Queries from './HubSpotVideoSearchRpc.dfc.new';
import type { AdditionalContextArgs } from './HubSpotVideoSearchRpc.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type MutationTupleOverride<Response, Request, DataOverride> = OverrideData<
  MutationTuple<Response, Request>,
  DataOverride
>;
type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseSearchQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.SearchResponseType>,
    References.SearchRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'search', References.SearchResponseType>
        : References.SearchResponseType)
    | undefined;
};

export function useSearchQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.SearchResponseType>,
    References.SearchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSearchQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.SEARCH_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            search: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return { data: legacyFormatData, ...rest } as UseSearchQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseSearchQueryReturn<T>;
}

type UseSearchLazyQueryReturn<T extends boolean> = LazyQueryResultTupleOverride<
  Record<'result', References.SearchResponseType>,
  References.SearchRequestType,
  T extends true
    ? Record<'search', References.SearchResponseType>
    : References.SearchResponseType
>;

export function useSearchLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.SearchResponseType>,
    References.SearchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSearchLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.SEARCH_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            search: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseSearchLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseSearchLazyQueryReturn<T>;
}

type UseSearchSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.SearchResponseType>,
    References.SearchRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'search', References.SearchResponseType>
    : References.SearchResponseType;
};

export function useSearchSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.SearchResponseType>,
    References.SearchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSearchSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(Queries.SEARCH_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            search: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseSearchSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseSearchSuspenseQueryReturn<T>;
}

type UseAdvancedSearchQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.AdvancedSearchResponseType>,
    References.AdvancedSearchRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'advancedSearch', References.AdvancedSearchResponseType>
        : References.AdvancedSearchResponseType)
    | undefined;
};

export function useAdvancedSearchQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.AdvancedSearchResponseType>,
    References.AdvancedSearchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseAdvancedSearchQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.ADVANCED_SEARCH_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            advancedSearch: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseAdvancedSearchQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseAdvancedSearchQueryReturn<T>;
}

type UseAdvancedSearchLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.AdvancedSearchResponseType>,
    References.AdvancedSearchRequestType,
    T extends true
      ? Record<'advancedSearch', References.AdvancedSearchResponseType>
      : References.AdvancedSearchResponseType
  >;

export function useAdvancedSearchLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.AdvancedSearchResponseType>,
    References.AdvancedSearchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseAdvancedSearchLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.ADVANCED_SEARCH_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            advancedSearch: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseAdvancedSearchLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseAdvancedSearchLazyQueryReturn<T>;
}

type UseAdvancedSearchSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.AdvancedSearchResponseType>,
    References.AdvancedSearchRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'advancedSearch', References.AdvancedSearchResponseType>
    : References.AdvancedSearchResponseType;
};

export function useAdvancedSearchSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.AdvancedSearchResponseType>,
    References.AdvancedSearchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseAdvancedSearchSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.ADVANCED_SEARCH_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            advancedSearch: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseAdvancedSearchSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseAdvancedSearchSuspenseQueryReturn<T>;
}

type UseAdvancedSearchWithVideosHydratedQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.AdvancedSearchWithVideosHydratedResponseType>,
    References.AdvancedSearchWithVideosHydratedRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'advancedSearchWithVideosHydrated',
            References.AdvancedSearchWithVideosHydratedResponseType
          >
        : References.AdvancedSearchWithVideosHydratedResponseType)
    | undefined;
};

export function useAdvancedSearchWithVideosHydratedQuery<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<'result', References.AdvancedSearchWithVideosHydratedResponseType>,
    References.AdvancedSearchWithVideosHydratedRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseAdvancedSearchWithVideosHydratedQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.ADVANCED_SEARCH_WITH_VIDEOS_HYDRATED_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            advancedSearchWithVideosHydrated: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseAdvancedSearchWithVideosHydratedQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseAdvancedSearchWithVideosHydratedQueryReturn<T>;
}

type UseAdvancedSearchWithVideosHydratedLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.AdvancedSearchWithVideosHydratedResponseType>,
    References.AdvancedSearchWithVideosHydratedRequestType,
    T extends true
      ? Record<
          'advancedSearchWithVideosHydrated',
          References.AdvancedSearchWithVideosHydratedResponseType
        >
      : References.AdvancedSearchWithVideosHydratedResponseType
  >;

export function useAdvancedSearchWithVideosHydratedLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.AdvancedSearchWithVideosHydratedResponseType>,
    References.AdvancedSearchWithVideosHydratedRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseAdvancedSearchWithVideosHydratedLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.ADVANCED_SEARCH_WITH_VIDEOS_HYDRATED_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            advancedSearchWithVideosHydrated: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseAdvancedSearchWithVideosHydratedLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseAdvancedSearchWithVideosHydratedLazyQueryReturn<T>;
}

type UseAdvancedSearchWithVideosHydratedSuspenseQueryReturn<T extends boolean> =
  Omit<
    UseSuspenseQueryResult<
      Record<'result', References.AdvancedSearchWithVideosHydratedResponseType>,
      References.AdvancedSearchWithVideosHydratedRequestType
    >,
    'data'
  > & {
    data: T extends true
      ? Record<
          'advancedSearchWithVideosHydrated',
          References.AdvancedSearchWithVideosHydratedResponseType
        >
      : References.AdvancedSearchWithVideosHydratedResponseType;
  };

export function useAdvancedSearchWithVideosHydratedSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.AdvancedSearchWithVideosHydratedResponseType>,
    References.AdvancedSearchWithVideosHydratedRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseAdvancedSearchWithVideosHydratedSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.ADVANCED_SEARCH_WITH_VIDEOS_HYDRATED_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            advancedSearchWithVideosHydrated: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseAdvancedSearchWithVideosHydratedSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseAdvancedSearchWithVideosHydratedSuspenseQueryReturn<T>;
}

type UseGetEmbeddedVectorsForVideoQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetEmbeddedVectorsForVideoResponseType>,
    References.GetEmbeddedVectorsForVideoRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getEmbeddedVectorsForVideo',
            References.GetEmbeddedVectorsForVideoResponseType
          >
        : References.GetEmbeddedVectorsForVideoResponseType)
    | undefined;
};

export function useGetEmbeddedVectorsForVideoQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetEmbeddedVectorsForVideoResponseType>,
    References.GetEmbeddedVectorsForVideoRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetEmbeddedVectorsForVideoQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_EMBEDDED_VECTORS_FOR_VIDEO_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getEmbeddedVectorsForVideo: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetEmbeddedVectorsForVideoQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetEmbeddedVectorsForVideoQueryReturn<T>;
}

type UseGetEmbeddedVectorsForVideoLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetEmbeddedVectorsForVideoResponseType>,
    References.GetEmbeddedVectorsForVideoRequestType,
    T extends true
      ? Record<
          'getEmbeddedVectorsForVideo',
          References.GetEmbeddedVectorsForVideoResponseType
        >
      : References.GetEmbeddedVectorsForVideoResponseType
  >;

export function useGetEmbeddedVectorsForVideoLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetEmbeddedVectorsForVideoResponseType>,
    References.GetEmbeddedVectorsForVideoRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetEmbeddedVectorsForVideoLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_EMBEDDED_VECTORS_FOR_VIDEO_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getEmbeddedVectorsForVideo: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetEmbeddedVectorsForVideoLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetEmbeddedVectorsForVideoLazyQueryReturn<T>;
}

type UseGetEmbeddedVectorsForVideoSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetEmbeddedVectorsForVideoResponseType>,
    References.GetEmbeddedVectorsForVideoRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getEmbeddedVectorsForVideo',
        References.GetEmbeddedVectorsForVideoResponseType
      >
    : References.GetEmbeddedVectorsForVideoResponseType;
};

export function useGetEmbeddedVectorsForVideoSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetEmbeddedVectorsForVideoResponseType>,
    References.GetEmbeddedVectorsForVideoRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetEmbeddedVectorsForVideoSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_EMBEDDED_VECTORS_FOR_VIDEO_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getEmbeddedVectorsForVideo: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetEmbeddedVectorsForVideoSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetEmbeddedVectorsForVideoSuspenseQueryReturn<T>;
}

type UseReprocessVideosForVisualSearchMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.ReprocessVideosForVisualSearchResponseType>,
    References.ReprocessVideosForVisualSearchRequestType,
    T extends true
      ? Record<
          'reprocessVideosForVisualSearch',
          References.ReprocessVideosForVisualSearchResponseType
        >
      : References.ReprocessVideosForVisualSearchResponseType
  >;

export function useReprocessVideosForVisualSearchMutation<
  T extends boolean = false,
>(
  options?: MutationHookOptions<
    Record<'result', References.ReprocessVideosForVisualSearchResponseType>,
    References.ReprocessVideosForVisualSearchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseReprocessVideosForVisualSearchMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.REPROCESS_VIDEOS_FOR_VISUAL_SEARCH_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            reprocessVideosForVisualSearch: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseReprocessVideosForVisualSearchMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseReprocessVideosForVisualSearchMutationReturn<T>;
}
